import React, { useState, useCallback, useEffect } from 'react';
import { Typography, Grid, Box } from '@mui/material';
import '../../../pages/EmployeeOnboarding/EmployeeOnboarding.css';
import Button from '@mui/material/Button';

import Tooltip from '@mui/material/Tooltip';
import PaginationComponent from '../../../components/Pagination/Pagination';
import KeycloakService from '../../../services/KeycloakService';
import { useDispatch } from 'react-redux';
import EmployeeCard from '../../../pages/EmployeeOnboarding/EmployeeCard';
import GenericLoader from '../../../components/Loader/GenericLoader';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import { CANCEL_BUTTON_TEXT, UserType, WFHAttribute } from '../../../constants';
import DeletableChips from '../../../components/Chip/DeletableChip';
import { getUsers, getAllEmployees } from '../../../services/UserService';
import {
  getDesignations,
  getLeaveGroups,
  getOfficeLocations,
  grantCurrentQuarterlyLeaveForAllEmployees,
} from '../../Services/MasterdataService';
import { getEligibleReportingManagers } from '../../Services/EmployeeMasterCsvService';
import { DialogBoxComponent } from '../../../components/DialogBox/DialogBoxCard';

import { addOrUpdateEmployeeByExcel } from '../../../services/EmployeeService';
const UserProfile = () => {
  const [isAdmin, setIsAdmin] = React.useState(true);
  const [employeeDetails, setEmployeeDetails] = useState({
    applierId: KeycloakService.getUserDetail(),
    employeeCode: '',
    firstName: '',
    lastName: '',
    designation: '',
    dateOfBirth: '',
    status: 'PENDING',
    phoneNumber: '',
    personalEmailId: '',
    dateOfJoining: '',
    organizationEmailId: '',
    usageLocation: '',
    jobType: '',
  });
  const [page, setPage] = React.useState(1);
  const [pageNo, setPageNo] = React.useState(0);
  // const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPage, setTotalPage] = useState();
  const [refreshPage, setRefreshPage] = useState(false);
  const [isProfile, setIsProfile] = useState(true);
  const [showErrorMessageExcel, setShowErrorMessageExcel] = useState(false);
  const [showErrorMessageExcelMessage, setShowErrorMessageExcelMessage] =
    useState(null);
  const [showErrorMessageExcel1, setShowErrorMessageExcel1] = useState(false);

  const [pageSize, setPageSize] = useState(3);

  const [showErrorMessageDob, setShowErrorMessageDob] = useState(false);
  const [showErrorMessageDoj, setShowErrorMessageDoj] = useState(false);
  const [showErrorMessageDoi, setShowErrorMessageDoi] = useState(false);
  const [showErrorMessagePEmail, setShowErrorMessagePEmail] = useState(false);
  const [showErrorMessageOEmail, setShowErrorMessageOEmail] = useState(false);
  const [showErrorMessagePhoneNo, setShowErrorMessagePhoneNo] = useState(false);
  const [showErrorMessageEmployeeId, setShowErrorMessageEmployeeId] = useState(false);

  const [loader, setLoader] = useState(false);
  const [users, setUsers] = useState([]);
  const [isLastActionFocus, setIsLastActionFocus] = useState(false);
  const [selected, setSelected] = useState('');
  const [allEmpDetails, setAllEmpDetails] = useState([]);
  const dispatch = useDispatch();
  const [isFocused, setIsFocused] = useState(false);
  const [designationNames, setDesignationNames] = useState([]);
  const [officeLocations, setOfficeLocations] = useState([]);
  const [leaveGroups, setLeaveGroups] = useState([]);
  const [reportingManagers, setReportingManagers] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [grantAllOpen, setGrantAllOpen] = useState(false);
  const [grantAllLoading, setGrantAllLoading] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
  };
  const handleBlur = () => {
    if (selected.length === 0) setIsFocused(false);
  };
  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: 'SHOW NOTIFICATION',
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 500);
    };
  };

  var designationData;

  const getAllDesignation = async () => {
    designationData = await getDesignations();

    const newDesignationNames = designationData.data.data.map(
      (data) => data.designationNames[0],
    );
    setDesignationNames(newDesignationNames);
  };

  const getAllOfficeLocations = async () => {
    const officeLocationData = await getOfficeLocations();
    setOfficeLocations(officeLocationData?.data?.data || []);
  };

  const getAllLeaveGroups = async () => {
    // Load all groups so an inactive but currently assigned group remains visible.
    const leaveGroupData = await getLeaveGroups();
    setLeaveGroups(leaveGroupData?.data?.data || []);
  };

  const getAllReportingManagers = async () => {
    const response = await getEligibleReportingManagers();
    setReportingManagers(response?.data?.data || []);
  };

  const canGrantQuarterlyLeave =
    KeycloakService.hasRole([UserType.ADMIN]) ||
    KeycloakService.hasRole([UserType.HR]);

  const confirmGrantAllQuarterlyLeave = async () => {
    setGrantAllLoading(true);
    const response = await grantCurrentQuarterlyLeaveForAllEmployees();
    setGrantAllLoading(false);
    setGrantAllOpen(false);
    if (response.isError === false) {
      const result = response.data?.data;
      const granted = result?.granted ?? 0;
      const processed = result?.processed ?? 0;
      dipatchNotification(
        'success',
        `Quarterly Casual Leave grant completed. Processed ${processed} employees, granted ${granted}.`,
      );
    } else {
      dipatchNotification(response.type, response.message);
    }
  };

  let uploadExcel;
  const handleUpload = async (e) => {
    setLoader(true);
    setSelectedFile(null);
    const file = e.target.files[0];
    if (
      file &&
      file.type !==
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ) {
      setLoader(false);
      setShowErrorMessageExcel1(true);
      setTimeout(() => {
        setShowErrorMessageExcel1(false);
      }, 3000);
      return;
    }
    uploadExcel = await addOrUpdateEmployeeByExcel(file);

    if (uploadExcel.data?.body?.length) {
      setLoader(false);
      setShowErrorMessageExcel(true);
      setShowErrorMessageExcelMessage(uploadExcel.data.body[0]);
      setTimeout(() => {
        setShowErrorMessageExcel(false);
      }, 3000);
    }

    getAllEmployeesDetails();
    setLoader(false);
    // You can call your API here using the selected file (file).
    // Implement your API call logic.
  };

  const getUsersDetails = async (searchString, pageSize) => {
    if (searchString?.length >= 2) {
      setIsLoading(true);
      const employeeList = await getUsers(
        searchString,
        pageSize,
        pageNo,
        'ACTIVE',
      );
      if (employeeList.isError === false) {
        setAllEmpDetails((prev) => []);
        setAllEmpDetails(employeeList.data.content);
        setTotalPage(employeeList.data.totalPages);
        if (employeeList?.data?.numberOfElements === 0) {
          setPageNo(0);
          setPage(1);
        }
        setIsLoading(false);
      }
      dipatchNotification(employeeList.type, employeeList.message);
    } else {
      setIsLoading(false);
    }
  };
  const searchEmployeeByName = useCallback(debounce(getUsersDetails), []);

  const getAllEmployeesDetails = async () => {
    const employeeListByStatus = await getUsers('', pageSize, pageNo, 'ACTIVE');
    if (employeeListByStatus?.status === 200) {
      setAllEmpDetails((prev) => []);
      setTotalPage(employeeListByStatus.data.totalPages);
      setAllEmpDetails([...employeeListByStatus.data.content]);
      if (employeeListByStatus?.data?.numberOfElements === 0) {
        setPageNo(0);
        setPage(1);
      }
    } else {
      if (employeeListByStatus?.status !== 200) {
        dipatchNotification(
          employeeListByStatus.type,
          employeeListByStatus.message,
        );
      }
      if (
        employeeListByStatus?.status === 200 &&
        !employeeListByStatus.data.totalPages
      ) {
        dipatchNotification(
          employeeListByStatus.type,
          'Total Pages Data Not Found',
        );
      }
    }
  };

  const handlePageSizeChange = async (event) => {
    const newPageSize = event.target.value;
    setPageSize(newPageSize);
    // getUsersDetails(selected,pageSize);
    pageChange(null, 1);
  };
  useEffect(() => {
    getAllDesignation();
    getAllOfficeLocations();
    getAllLeaveGroups();
    getAllReportingManagers();
    getAllEmployeesDetails();
  }, []);
  useEffect(() => {
    getUsersDetails(selected, pageSize);
    if (selected.length <= 1) {
      getAllEmployeesDetails();
    }
  }, [refreshPage]);

  const pageChange = (event, value) => {
    setPageNo(value - 1);
    setPage(value);
    setRefreshPage(!refreshPage);
  };
  return (
    <div style={{ width: '100%' }}>
      <div style={{ width: '100%' }}>
        {loader ? (
          <div>
            <GenericLoader rectAttributes={WFHAttribute} />
          </div>
        ) : (
          <div>
            <div style={{}}>
              <Box
                sx={{
                  paddingTop: '1rem',
                  paddingBottom: '0.5rem',
                  width: '95%',
                  justifyContent: 'space-between',
                  display: 'flex',
                }}
              >
                <TextField
                  label="Employee Name / ID"
                  name="color"
                  sx={{ width: '30%' }}
                  onChange={(e) => {
                    const inputText = e.target.value;
                    if (inputText !== '') {
                      setPage(1);
                      setPageNo(0);
                      searchEmployeeByName(inputText, pageSize);
                      setSelected(inputText);
                    } else {
                      setSelected('');
                      getAllEmployeesDetails();
                    }
                  }}
                  value={isLastActionFocus ? '' : selected}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  InputLabelProps={
                    !isFocused
                      ? {
                          sx: {
                            transform: 'translate(10%, 25%)',
                          },
                        }
                      : {}
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                    sx: {
                      '& input': {
                        height: '5px', // Adjust the height value as needed
                      },
                    },
                  }}
                />

                {canGrantQuarterlyLeave ? (
                  <Button
                    variant="contained"
                    onClick={() => setGrantAllOpen(true)}
                    disabled={grantAllLoading}
                    style={{
                      marginTop: '0.5rem',
                      backgroundColor: '#3f51b5',
                      color: '#fff',
                      height: '40px',
                    }}
                  >
                    Grant Quarterly Leave
                  </Button>
                ) : null}

                {/* Styled Upload button */}
                <label htmlFor="upload-button">
                  <input
                    id="upload-button"
                    type="file"
                    style={{ display: 'none' }}
                    onChange={handleUpload}
                  />
                  <Tooltip
                    open={showErrorMessageExcel || showErrorMessageExcel1}
                    title={
                      showErrorMessageExcel
                        ? showErrorMessageExcelMessage
                        : showErrorMessageExcel1
                          ? 'Please select xlsx file'
                          : ''
                    }
                    classes={{
                      tooltip: 'custom-tooltip1',
                      arrow: 'custom-tooltip-arrow1',
                    }}
                    placement="bottom"
                  >
                    {/* <Button
                      variant="contained"
                      component="span"
                      style={{
                        cursor: 'pointer',
                        marginTop: '0.5rem',
                        backgroundColor: '#3f51b5',
                        color: '#fff',
                      }}
                    >
                      Upload Excel
                    </Button> */}
                  </Tooltip>
                </label>
              </Box>
            </div>
            {allEmpDetails?.length !== 0 ? (
              allEmpDetails?.map((employee) => (
                <EmployeeCard
                  designationNames={designationNames}
                  officeLocations={officeLocations}
                  leaveGroups={leaveGroups}
                  reportingManagers={reportingManagers}
                  refreshPage={refreshPage}
                  isProfile={isProfile}
                  Files={1}
                  employee={employee}
                  UpdatedEmployeePhoto={employee?.photoPath}
                  EmployeeDetails={employeeDetails}
                  ShowErrorMessageDob={showErrorMessageDob}
                  ShowErrorMessageDoj={showErrorMessageDoj}
                  ShowErrorMessageDoi={showErrorMessageDoi}
                  ShowErrorMessageOEmail={showErrorMessageOEmail}
                  ShowErrorMessagePEmail={showErrorMessagePEmail}
                  ShowErrorMessagePhoneNo={showErrorMessagePhoneNo}
                  showErrorMessageEmployeeId={showErrorMessageEmployeeId}
                />
              ))
            ) : (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '60vh',
                }}
              >
                <div>
                  <Typography>{'No Employee Requests..'}</Typography>
                </div>
              </div>
            )}

            {allEmpDetails?.length ? (
              <Box className="page-holder" sx={{ mt: 1, mb: 1 }}>
                <PaginationComponent
                  count={totalPage}
                  page={page}
                  pageChange={pageChange}
                  pageSize={pageSize}
                  handlePageSizeChange={handlePageSizeChange}
                />
              </Box>
            ) : (
              <></>
            )}
            <DialogBoxComponent
              open={grantAllOpen}
              fullWidth
              handleClose={() => {
                if (!grantAllLoading) {
                  setGrantAllOpen(false);
                }
              }}
              title="Grant Quarterly Leave?"
              content={
                <>
                  <Typography variant="body1">
                    Grant quarterly Casual Leave to all eligible employees?
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    This will process the current quarter using each employee's
                    current Leave Group and applicable band.
                  </Typography>
                </>
              }
              onCancel={() => setGrantAllOpen(false)}
              cancelText={CANCEL_BUTTON_TEXT}
              onConfirm={confirmGrantAllQuarterlyLeave}
              confirmText={grantAllLoading ? 'Granting...' : 'Grant'}
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default UserProfile;
